class ProductSwatches extends HTMLElement {
  constructor() {
    super();
    this.swatchElements = this.querySelectorAll('.metacolour-swatch__parent');
    this.activeTitleEL = this.querySelector('[data-active-title]');

    this.handleME = this.handleME.bind(this);
    this.handleML = this.handleML.bind(this);
  }

  handleME(e) {
    const swatch = e.currentTarget;
    const newTitle = swatch.getAttribute('data-swatch-name');
    if (!newTitle) return;
    this.activeTitleEL.setAttribute('data-original-text', this.activeTitleEL.textContent);
    this.activeTitleEL.textContent = newTitle;
  }

  handleML(e) {
    this.activeTitleEL.textContent = this.activeTitleEL.getAttribute('data-original-text');
  }

  connectedCallback() {
    if(!this.swatchElements.length) return;
    this.swatchElements.forEach(swatch => {
      swatch.addEventListener('mouseenter', this.handleME);
      swatch.addEventListener('mouseleave', this.handleML);
    });

  }

  disconnectedCallback() {
    if(!this.swatchElements.length) return;
    this.swatchElements.forEach(swatch => {
      swatch.removeEventListener('mouseenter', this.handleME);
      swatch.removeEventListener('mouseleave', this.handleML);
    });

  }
}

if (!customElements.get('product-swatches')) {
  customElements.define('product-swatches', ProductSwatches)
}